import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash, faFileExcel, faDownload } from "@fortawesome/free-solid-svg-icons";
import { Button, useDisclosure, Select, SelectItem, Modal, ModalBody, ModalHeader, ModalContent } from "@heroui/react";
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_MOD_NAME, ENUM_PAGEACTION_TYPE, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/demandEntrySlice";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useModalToast } from "../../components/modalToast/ModalToastContext";

const DemandMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode, compName, isMultipleCompany, compLogo } = useSelector((state) => state.company)
    const { show } = useModalToast();
    const [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")
    const [selTemplate, setSelTemplate] = useState("")
    const [selRowData, setSelRowData] = useState({})
    const [exportTempColumn, setExportTempColumn] = useState([])
    const [msg, setMsg] = useState("")
    const {
        isOpen: isOpenReportModel,
        onOpen: onOpenReportModel,
        onOpenChange: onOpenReportModelChange,
    } = useDisclosure()
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

    }, [])
    // Fetch shape data
    const {
        data,
        isPending,
        isError,
        mutate: filterData
    } = usePost({
        url: apiRoute.demandMaster.fetch,
        queryKey: "fetchDemandMaster",
    });

    const { isError: isErrorXlTemp, data: templateSetting = [], mutate: filterTemplate } = usePost({
        url: apiRoute.mapping.GetExcelTemp,
        queryKey: "fetchExcelTemplate",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {

            }
        }
    })

    // const sel_ExportColumn = useMemo(() => {
    //     if (templateSetting && templateSetting.length > 0) {
    //         const exportCol = templateSetting.map((ele) => {
    //             return ({
    //                 uid: ele.tb_col_name, name: ele.xl_col_name, type: ['bweight', 'amount', 'amountd', 'pcs'].includes(ele.tb_col_name) ? "number" : ""
    //             })
    //         })
    //         setExportTempColumn(exportCol)
    //         return exportCol
    //     }
    //     else
    //         return []
    // }, [templateSetting])

    const handleViewChange = (val) => {
        setSelTemplate(val)
        filterTemplate({
            data: {
                tempid: val
            }
        })
    }
    const funLoadData = () => {
        filterData({
            data: { compcode: compCode.join(",") }
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])

    const { data: masterData = [] } = useFetchWithBody({
        url: apiRoute.stockEntry.reportMasterData,
        queryKey: "StockItemMaster",
    })
    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingDemand",
        inputData: {
            mod_name: ENUM_MOD_NAME.DemandGeneration
        }
    })

    const {
        data: reportData = [],
        mutate: funGetReportData } = usePostMutateWithSuccess({
            url: apiRoute.demandMaster.getReportData,
            queryKey: "fetchDemandReportDetail",
        });

    const onSuccessDelete = () => {
        setItemToDelete("")
        funLoadData()
    };

    // Delete shape mutation
    const { mutate: fnDelete } = usePost({
        url: apiRoute.demandMaster.deleteEntry,
        queryKey: "deleteDemandMaster",
        onSuccessTasks: onSuccessDelete,
        //successMessage: "Item Group deleted successfully!",
    });
    const reportModel = () => {
        return (
            <div>
                <Modal
                    isOpen={isOpenReportModel}
                    onOpenChange={onOpenReportModelChange}
                    size="sm"
                    placement="center"
                    scrollBehavior="inside"
                    radius="sm"
                >
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalHeader className="uppercase text-sm m-0 px-2  shadow-sm rounded-xl bg-grday-100 border-b-2 border-blfue-700">
                                    Download Stock View Type
                                </ModalHeader>
                                <ModalBody className=" p-5">
                                    {msg && msg != "" && msg != null && <h2 className="text-red-700 bg-amber-50 text-sm  p-2 text-center" >{msg}</h2>}
                                    <div className="h-full flex gap-5 items-baseline">
                                        <Select
                                            size="sm"
                                            isRequired
                                            name={"View"}
                                            color={"danger"}
                                            label={"View Type"}
                                            eventResizeFeature={true}
                                            selectionMode="single"
                                            labelPlacement="outside"
                                            showScrollIndicators={true}
                                            placeholder={"select"}
                                            className="w-full sm:w-40 font-semibold"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            isClearable={false}
                                            variant="flat"
                                            isVirtualized
                                            items={
                                                masterData && masterData?.tempMaster ? masterData.tempMaster : []
                                            }
                                            onChange={(e) => handleViewChange(e.target.value)}
                                            selectedKeys={[selTemplate]}
                                        >
                                            {(list) => (
                                                <SelectItem key={list.TempleteID}>
                                                    {list.TempleteName}
                                                </SelectItem>
                                            )}
                                        </Select>
                                        <button onClick={() => handleExportStock(selRowData)}
                                            className="bg-rose-600 text-white whitespace-nowrap h-7 px-3 py-1 rounded text-sm"
                                        >Export<FontAwesomeIcon className="mx-2" icon={faDownload}></FontAwesomeIcon></button>
                                    </div>
                                </ModalBody>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            </div>
        )
    }
    const exportColumns = [
        {
            name: "Party",
            uid: "PartyName",
        },
        {
            name: "Details",
            uid: "Dem_Details"
        },
        {
            name: "Dem. No NAME",
            uid: "Dem_No",
        },
        {
            name: "Date",
            uid: "Dem_Date",
            type: COLUMN_TYPE.date
        },
    ]

    let downloadDataFooter = {
        PartyName: "",
        Dem_Details: "",
        Dem_No: "",
        Dem_Date: ""
    }

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete && itemToDelete != null)
                fnDelete({ data: { transaction_id: itemToDelete, comp_code: compCode.join(",") } });
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                dispatch(setDetailParams(itemToEdit));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.demand.createDemandMaster);
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.demand.createDemandMaster);
    };

    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Party", uid: "PartyName", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Dem.No", uid: "Dem_No", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Details", uid: "Dem_Details", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.multiline },
        { name: "Date", uid: "Dem_Date", sortable: true, type: COLUMN_TYPE.date, align: COLUMN_ALIGN_TYPE.center },
    ];



    // Excel Template Configuration
    // const excelTemplate = [
    //     // paste your template array here
    // ];


    const exportDemandReport = async (data, headData, logo) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Demand Stock");
        const header = headData;

        // if (logo && logo !== "") {

        //     const imageId = workbook.addImage({
        //         base64: logo,
        //         extension: 'jpeg',
        //     });

        //     worksheet.addImage(imageId, {
        //         tl: { col: 0, row: 0 },
        //         ext: { width: 120, height: 60 },
        //     });
        //     const logoWidthCols = 2;
        //     const nameStartCol = logoWidthCols + 1;
        //     const nameEndCol = exportColumns.length;
        //     worksheet.mergeCells(1, nameStartCol, 1, nameEndCol);

        //     const titleCell = worksheet.getCell(1, nameStartCol);
        //     titleCell.value = compName.join(",");
        //     titleCell.font = { size: 16, bold: true };
        //     titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
        //     worksheet.getRow(1).height = 50;
        // }
        // else {
        // Company Name
        worksheet.mergeCells("A1:M1");
        worksheet.getCell("A1").value = compName.join(",");
        worksheet.getCell("A1").font = {
            bold: true,
            size: 18,
        };
        worksheet.getCell("A1").alignment = {
            horizontal: "center",
        };

        // Report Name
        worksheet.mergeCells("A2:M2");
        worksheet.getCell("A2").value =
            `Demand Report (generated On: ${new Date().toLocaleString()})`;

        worksheet.getCell("A2").font = {
            bold: true,
            size: 10,
        };

        worksheet.getCell("A2").alignment = {
            horizontal: "center",
        };

        //  }
        worksheet.addRow([]);

        // Information
        const row4 = worksheet.addRow([
            "Demand No",
            header.Dem_No,
            "",
            "Date",
            new Date(header.Dem_Date).toLocaleDateString(),
        ]);

        row4.getCell(1).font = { bold: true };
        row4.getCell(4).font = { bold: true };


        const row5 = worksheet.addRow([
            "Party",
            header.PartyName,
        ]);

        row5.getCell(1).font = { bold: true };
        worksheet.addRow([]);

        // ==============================
        // Dynamic Excel Header
        // ==============================

        const sortedTemplate = templateSetting.sort(
            (a, b) => Number(a.xl_col_no) - Number(b.xl_col_no)
        );

        const excelHeaders = [
            "Sr No",
            ...sortedTemplate.map(
                item => item.xl_col_name.trim()
            )
        ];

        const headerRow = worksheet.addRow(excelHeaders);
        // Add filter to all columns
        worksheet.autoFilter = {
            from: {
                row: headerRow.number,
                column: 1
            },
            to: {
                row: headerRow.number,
                column: excelHeaders.length
            }
        };

        headerRow.eachCell((cell) => {

            cell.font = {
                bold: true,
                color: {
                    argb: "FFFFFFFF",
                },
            };

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                    argb: "4472C4",
                },
            };

            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
                bottom: { style: "thin" },
            };

            cell.alignment = {
                horizontal: "center",
                vertical: "middle",
            };

        });

        // ==============================
        // Dynamic Data Rows
        // ==============================

        data.forEach((item, index) => {

            const row = worksheet.addRow([
                index + 1,
                ...sortedTemplate.map(col => item[col.tb_col_name] ?? "")
            ]);


            // Make Image & Video columns clickable
            sortedTemplate.forEach((col, colIndex) => {

                const excelCell = row.getCell(colIndex + 2);
                // +2 because first column is Sr No


                if (
                    col.tb_col_name === "imgfile" &&
                    item.imgfile
                ) {

                    excelCell.value = {
                        text: item.imgfile,
                        hyperlink: item.imgfile
                    };

                    excelCell.font = {
                        color: {
                            argb: "FF0000FF"
                        },
                        underline: true
                    };

                }


                if (
                    col.tb_col_name === "videofile" &&
                    item.videofile
                ) {

                    excelCell.value = {
                        text: item.imgfile,
                        hyperlink: item.videofile
                    };

                    excelCell.font = {
                        color: {
                            argb: "FF0000FF"
                        },
                        underline: true
                    };

                }

            });

        });

        // ==============================
        // Borders
        // ==============================

        worksheet.eachRow((row, rowNumber) => {

            if (rowNumber >= 7) {

                row.eachCell(cell => {

                    cell.border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        right: { style: "thin" },
                        bottom: { style: "thin" },
                    };

                });

            }

        });



        // ==============================
        // Dynamic Column Width
        // ==============================

        worksheet.columns = [
            {
                width: 8
            },
            ...sortedTemplate.map(col => ({

                width:
                    Math.max(
                        col.xl_col_name.length + 5,
                        12
                    )

            }))
        ];



        const buffer = await workbook.xlsx.writeBuffer();


        saveAs(
            new Blob([buffer]),
            `Demand_Stock_${header.Dem_No}.xlsx`
        );

    };

    const handleExportStock = (row) => {
        if (selTemplate && selTemplate != "" && selTemplate != null) {
            setMsg("")
            funGetReportData(
                {
                    data: {
                        compcode: row?.CompCode,
                        transactionid: row?.TransactionId,
                        action: ''
                    },
                    onSuccess: (data) => {
                        if (data && data?.length > 0)
                            exportDemandReport(data, row, compLogo[0])
                        else
                            setMsg("No Matching Stock Found For Demand")
                    }
                })
        }
        else {
            setMsg("Select View Type")
            return;
        }
    }
    
    const exportDemandSummary = async (data) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Demand Summary");

        const headerData = data?.[0] || {};

        // ===========================
        // Column Configuration
        // ===========================
        const allColumns = [
            { Parameter: "Size", Header: "Weight", Key: "Weight" },
            { Parameter: "Shape", Header: "Shape", Key: "ShapeName" },
            { Parameter: "Color", Header: "Color", Key: "ColorName" },
            { Parameter: "Purity", Header: "Purity", Key: "PurityName" },
            { Parameter: "Lab", Header: "Lab", Key: "LabId" },
            { Parameter: "Diameter", Header: "Dia", Key: "Dia" },
            { Parameter: "Length", Header: "Length", Key: "StnLength" },
            { Parameter: "Flrcn", Header: "Flrcn", Key: "Flrn" },
            { Parameter: "Cut", Header: "Cut", Key: "CutName" },
            { Parameter: "Polish", Header: "Polish", Key: "PolishName" },
            { Parameter: "Symtry", Header: "Symmetry", Key: "SymtryName" }
        ];

        // ===========================
        // Filter Columns From Settings
        // ===========================
        const excelColumns = allColumns.filter((col) => {
            const config = modSetting.find(
                (x) => x.Parameter.toLowerCase() === col.Parameter.toLowerCase()
            );

            if (config) {
                return config.Visible === "true";
            }

            return true;
        });

        // ===========================
        // Initial Columns
        // ===========================
        const visibleColumns = [
            {
                Header: "Location",
                Key: "Location"
            },
            ...excelColumns,
            {
                Header: "Total Stock",
                Key: "TotalStock"
            },
            {
                Header: "Total Weight",
                Key: "TotalWeight"
            }
        ];

        // ===========================
        // Remove Empty Columns
        // ===========================
        const finalColumns = visibleColumns.filter((col) => {
            // Always keep these columns
            if (
                col.Key === "Location" ||
                col.Key === "TotalStock" ||
                col.Key === "TotalWeight"
            ) {
                return true;
            }

            return data.some((row) => {
                const value = row[col.Key];

                return (
                    value !== null &&
                    value !== undefined &&
                    value !== ""
                );
            });
        });

        const totalCols = finalColumns.length;
        const lastColumn = String.fromCharCode(64 + totalCols);

        // ===========================
        // Company Name
        // ===========================
        worksheet.mergeCells(`A1:${lastColumn}1`);

        worksheet.getCell("A1").value = compName.join(",");

        worksheet.getCell("A1").font = {
            bold: true,
            size: 18
        };

        worksheet.getCell("A1").alignment = {
            horizontal: "center"
        };

        // ===========================
        // Report Name
        // ===========================
        worksheet.mergeCells(`A2:${lastColumn}2`);

        worksheet.getCell("A2").value =
            `Demand Report (Generated On ${new Date().toLocaleString()})`;

        worksheet.getCell("A2").font = {
            bold: true,
            size: 11
        };

        worksheet.getCell("A2").alignment = {
            horizontal: "center"
        };

        worksheet.addRow([]);

        // ===========================
        // Demand Info
        // ===========================
        // Demand No & Date
        const infoRow1 = worksheet.addRow([
            "Demand No",
            headerData.Dem_No || "",
            "Date",
            headerData.Dem_Date
                ? new Date(headerData.Dem_Date).toLocaleDateString()
                : ""
        ]);

        infoRow1.getCell(1).font = { bold: true };
        infoRow1.getCell(3).font = { bold: true };

        // Party on new row
        const infoRow2 = worksheet.addRow([
            "Party",
            headerData.PartyName || ""
        ]);

        infoRow2.getCell(1).font = { bold: true };

        worksheet.addRow([]);

        // ===========================
        // Header
        // ===========================
        const excelHeader = worksheet.addRow(
            finalColumns.map((col) => col.Header)
        );

        excelHeader.eachCell((cell) => {
            cell.font = {
                bold: true,
                color: {
                    argb: "FFFFFFFF"
                }
            };

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                    argb: "4472C4"
                }
            };

            cell.alignment = {
                horizontal: "center",
                vertical: "middle"
            };

            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
                bottom: { style: "thin" }
            };
        });

        // ===========================
        // Data Rows
        // ===========================
        data.forEach((item) => {
            const rowValues = finalColumns.map((col) => item[col.Key] ?? "");

            const row = worksheet.addRow(rowValues);

            row.eachCell((cell) => {
                cell.alignment = {
                    horizontal: "center",
                    vertical: "middle",
                    wrapText: true
                };

                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" },
                    bottom: { style: "thin" }
                };
            });
        });

        // ===========================
        // Totals Row
        // ===========================
        const totalStock = data.reduce(
            (sum, item) => sum + (Number(item.TotalStock) || 0),
            0
        );

        const totalWeight = data.reduce(
            (sum, item) => sum + (Number(item.TotalWeight) || 0),
            0
        );

        const totalRowData = finalColumns.map((col) => {
            switch (col.Key) {
                case "Location":
                    return "TOTAL";
                case "TotalStock":
                    return totalStock;
                case "TotalWeight":
                    return totalWeight.toFixed(2);
                default:
                    return "";
            }
        });

        const totalRow = worksheet.addRow(totalRowData);

        totalRow.eachCell((cell) => {
            cell.font = {
                bold: true
            };

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                    argb: "D9EAD3"
                }
            };

            cell.alignment = {
                horizontal: "center",
                vertical: "middle"
            };

            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
                bottom: { style: "thin" }
            };
        });

        // ===========================
        // Auto Width
        // ===========================
        worksheet.columns.forEach((column) => {
            let maxLength = 8;

            column.eachCell({ includeEmpty: true }, (cell) => {
                const value = cell.value ? cell.value.toString() : "";
                maxLength = Math.max(maxLength, value.length);
            });

            column.width = Math.min(maxLength + 2, 20);
        });

        // ===========================
        // Freeze Header
        // ===========================
        worksheet.views = [
            {
                state: "frozen",
                ySplit: 6
            }
        ];

        // ===========================
        // Export
        // ===========================
        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(
            new Blob([buffer]),
            `Demand_Summary_${headerData.Dem_No || "Report"}.xlsx`
        );
    };
    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    trans_id: row.TransactionId,
                    comp_code: row.CompCode
                };
                setItemToEdit(obj)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete(row.TransactionId)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faFileExcel} style={{ color: "#FFFFFF" }} />,
            onClick: (row) => {
                setSelRowData(row)
                onOpenReportModel()

            },
            type: ROW_ACTION_BTN_TYPE.button,
            label: "Stock"
        },
        {
            icon: <FontAwesomeIcon icon={faDownload} style={{ color: "#FFFFFF" }} />,
            onClick: (row) => {
                funGetReportData(
                    {
                        data: {
                            compcode: row?.CompCode,
                            transactionid: row?.TransactionId,
                            action: 'Summary'
                        },
                        onSuccess: (data) => {
                            if (data && data?.length > 0)
                                exportDemandSummary(data)
                            else
                                show("No Matching Stock Found For Demand")

                        }
                    })
            },
            type: ROW_ACTION_BTN_TYPE.button,
            label: "Summary",
            color: "bg-amber-500"
        },
    ];

    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <div>
            <MainContainer pageName="Demand Master" breadcrumbs={["Sales", "Demand Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>

                </div>
                {reportModel()}
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "PartyName", "Dem_No", "Dem_Details", "Dem_Date"]}
                    data={data}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    showAdvanceFilter={false}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="Demand-master-List"
                    id="TransactionId"

                />
            </MainContainer>


            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}
        </div>
    );
};

export default DemandMaster;
